exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#panda-XXXX[data-v-0c513ae5] {\r\n  height: 85vh;\n}\n@media (max-width: 600px) {\n#panda-XXXX[data-v-0c513ae5] {\r\n    height: 400px;\n}\n}\r\n", ""]);

// exports
